import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { OperatorContact } from "@/components/legal/OperatorContact";
import { OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function TermsPage() {
  return (
    <LegalLayout
      title="Terms and Conditions"
      subtitle={`Rules for using ${OPERATOR.product}.`}
    >
      <LegalSection title="1. Agreement">
        <LegalP>
          By accessing or using {OPERATOR.product} (app or web), you agree to these Terms, our{" "}
          <Link to="/privacy" className={tw.link}>
            Privacy Policy
          </Link>
          , and{" "}
          <Link to="/guidelines" className={tw.link}>
            Community Guidelines
          </Link>
          . If you do not agree, do not use the service.
        </LegalP>
        <OperatorContact />
      </LegalSection>

      <LegalSection title="2. Eligibility">
        <LegalP>
          You must be at least <strong>13 years old</strong> (or the minimum age in your country)
          and able to form a binding contract. You are responsible for your account credentials
          and all activity under your account.
        </LegalP>
      </LegalSection>

      <LegalSection title="3. Your account">
        <LegalUl
          items={[
            "Provide accurate registration information, including a valid email and mobile number where required.",
            "Keep your password confidential and notify us of unauthorized access.",
            "One person per account unless we explicitly allow otherwise (e.g. Parallel collab on content, not shared login).",
            "We may suspend or terminate accounts that violate these Terms or applicable law.",
          ]}
        />
      </LegalSection>

      <LegalSection title="4. Your content">
        <LegalP>
          You retain ownership of content you post. You grant {OPERATOR.product} a worldwide,
          non-exclusive, royalty-free licence to host, store, display, and distribute your
          content solely to operate the service (feeds, CDN, chat, Parallel, etc.). You represent
          that you have the rights to post your content and that it does not infringe others’
          rights.
        </LegalP>
      </LegalSection>

      <LegalSection title="5. Acceptable use">
        <LegalP>
          You must follow our{" "}
          <Link to="/guidelines" className={tw.link}>
            Community Guidelines
          </Link>
          . Prohibited conduct includes harassment, hate speech, illegal content, spam,
          impersonation, malware, scraping, reverse engineering, and circumventing security or
          monetization systems.
        </LegalP>
      </LegalSection>

      <LegalSection title="6. Digital purchases & payments">
        <LegalP>
          Direct INR payments for creator tips, subscriptions, content unlocks, and promotions
          are governed by our{" "}
          <Link to="/payments" className={tw.link}>
            Payments
          </Link>{" "}
          policy and{" "}
          <Link to="/RefundandCancellation" className={tw.link}>
            Refund and Cancellation Policy
          </Link>
          . We do not sell virtual currency or wallet credits. Sparks are reward points without
          cash value. Creator payouts, where offered, follow the terms shown at purchase and our
          creator policies.
        </LegalP>
      </LegalSection>

      <LegalSection title="7. Ads">
        <LegalP>
          Free tiers may include ads served by third parties. See our{" "}
          <Link to="/ads" className={tw.link}>
            Advertising
          </Link>{" "}
          disclosure.
        </LegalP>
      </LegalSection>

      <LegalSection title="8. Third-party services">
        <LegalP>
          The service integrates Supabase, Cloudflare, Firebase, Cashfree Payments, and Google
          AdMob. Your use of those services may be subject to their terms. Links to other websites
          are not our endorsement.
        </LegalP>
      </LegalSection>

      <LegalSection title="9. Disclaimers">
        <LegalP>
          {OPERATOR.product} is provided &quot;as is&quot; without warranties of uninterrupted or
          error-free operation. We do not guarantee reach, earnings, or preservation of any
          particular content beyond our stated retention practices.
        </LegalP>
      </LegalSection>

      <LegalSection title="10. Limitation of liability">
        <LegalP>
          To the maximum extent permitted by law, {OPERATOR.name} and {OPERATOR.product} are not
          liable for indirect, incidental, or consequential damages. Our total liability for any
          claim arising from the service is limited to the greater of (a) amounts you paid us in
          the 12 months before the claim, or (b) ₹5,000 INR, except where law requires otherwise.
        </LegalP>
      </LegalSection>

      <LegalSection title="11. Termination">
        <LegalP>
          You may stop using the service anytime and delete your account per our{" "}
          <Link to="/data-deletion" className={tw.link}>
            Data deletion
          </Link>{" "}
          instructions. We may suspend or terminate access for violations or risk to users or the
          platform.
        </LegalP>
      </LegalSection>

      <LegalSection title="12. Governing law">
        <LegalP>
          These Terms are governed by the laws of India. Courts in Kadapa, Andhra Pradesh, shall
          have exclusive jurisdiction, subject to applicable consumer protection laws.
        </LegalP>
      </LegalSection>

      <LegalSection title="13. Contact">
        <LegalP>
          Questions about these Terms:{" "}
          <a href="mailto:support@daywia.com" className={tw.link}>
            support@daywia.com
          </a>
          ,{" "}
          <a href="mailto:admin@daywia.com" className={tw.link}>
            admin@daywia.com
          </a>
          .
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
